import template from './ordinacijaForm.html';
import angular from 'angular';

class OrdinacijaFormController {
    constructor() {
        this.step = 1;
    }

    $onInit() {
        this.step1Fields = this.fields[0];
        this.step2Fields = this.fields[1];
        this.model = angular.copy(this.item);
    }

    show(step) {
        this.step = step;
    }

    next() {
        if(this.step < 2) {
            this.step++;
        }
    }

    prev() {
        if(this.step > 1) {
            this.step--;
        }
    }

    submit(item) {
         this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.onSubmit({item: item});
    }
}

OrdinacijaFormController.$inject = [];

const OrdinacijaFormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: OrdinacijaFormController,
    controllerAs: 'vm',
    bindings: {
        fields: '<',
        item: '<',
        onSubmit: '&'
    }
};

export {OrdinacijaFormComponent};
export {OrdinacijaFormController};



// WEBPACK FOOTER //
// ./app/components/ordinacija/ordinacijaForm.component.js